import { connect } from 'react-redux'
import Layout from '../pages/Layout'
import { logout } from '../modules/Auth/actions'
import { fetchADPConfigurations } from '../modules/Common/actions'

const mapStateToProps = ({ auth, common }) => ({
    user_details: auth.user,
    pageNotifications: common.pageNotifications,
    adp_configurations: common.adp_configurations,
    has_adp_configurations_failed: common.has_adp_configurations_failed,
})

const mapDispatchToProps = {
    logout,
    fetchADPConfigurations,
}

export default connect(mapStateToProps, mapDispatchToProps)(Layout)
